<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Add Key Date - {{keyDateName}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">

  <div class="mb-3">
    <label class="form-label">Date</label>
    <input type="date" class="form-control" [(ngModel)]="keyDateValue" />
  </div>

</div>

<div class="modal-footer">

  <button *ngIf="!loading" type="button" class="btn btn-success"
    [disabled]="keyDateValue == null || saveButtonDisabled"
    (click)="saveKeyDate()">Save</button>

  <button *ngIf="loading" type="button" class="btn btn-outline-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    Saving...
  </button>
</div>